// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const teddiursa: PokeData = {
  "id": 216,
  "name": "teddiursa",
  "height": 6,
  "weight": 88,
  "base_experience": 66,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "scratch",
    "tackle",
    "thrash",
    "double-edge",
    "leer",
    "lick",
    "fury-swipes",
    "rest",
    "slash",
    "snore",
    "feint-attack",
    "charm",
    "sweet-scent",
    "fake-tears",
    "covet",
    "payback",
    "fling",
    "bulldoze",
    "play-rough",
    "play-nice",
    "baby-doll-eyes",
    "high-horsepower"
  ],
  "moves": [
    "scratch",
    "tackle",
    "leer",
    "lick",
    "play-rough",
    "refresh",
    "headbutt",
    "splash",
    "tri-attack",
    "growl",
    "supersonic",
    "quick-attack",
    "scary-face"
  ],
  "evolution_chain": {
    "id": 110,
    "item": null,
    "species": [
      {
        "name": "teddiursa",
        "order": 247,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ursaring",
        "order": 248,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 216,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "ursaluna",
        "order": 901,
        "types": [
          PokeType.GROUND,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 217,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "peat-block"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "full-moon",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 40,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
